<script>
import Layout from "../../layouts/main";

import appConfig from "@/app.config";

export default {
  page: {
    title: "Offcanvas page",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      title: "Offcanvas",
      items: [
        {
          text: "UI Elements",
          href: "/",
        },
        {
          text: "Offcanvas",
          active: true,
        },
      ],
    };
  },
  methods: {},
};
</script>

<template>
  <Layout :pagetitle="title">
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title">Demo</h5>
          </div>
          <div class="card-body">
            <p class="card-title-desc">
              Use the buttons below to show and hide an offcanvas element via
              JavaScript that toggles the <code>.show</code> class on an element
              with the <code>.offcanvas</code> class.
            </p>

            <div class="d-flex flex-wrap gap-2">
              <a
                class="btn btn-primary"
                data-bs-toggle="offcanvas"
                href="#offcanvasExample"
                role="button"
                aria-controls="offcanvasExample"
              >
                Link with href
              </a>
              <button
                class="btn btn-primary"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample"
              >
                Button with data-bs-target
              </button>
            </div>

            <div
              class="offcanvas offcanvas-start"
              tabindex="-1"
              id="offcanvasExample"
              aria-labelledby="offcanvasExampleLabel"
            >
              <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="offcanvasExampleLabel">
                  Offcanvas
                </h5>
                <button
                  type="button"
                  class="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div class="offcanvas-body">
                <div>
                  Some text as placeholder. In real life you can have the
                  elements you have chosen. Like, text, images, lists, etc.
                </div>
                <div class="dropdown mt-3">
                  <button
                    class="btn btn-primary"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                  >
                    Dropdown button <i class="mdi mdi-chevron-down"></i>
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <li><a class="dropdown-item" href="#">Action</a></li>
                    <li>
                      <a class="dropdown-item" href="#">Another action</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#">Something else here</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- end card body  -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->

      <div class="col-lg-6">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title">Placement</h5>
          </div>
          <div class="card-body">
            <p class="card-title-desc">
              Offcanvas Diffrent Placement Example: Left, Right & Bottom
            </p>

            <div class="d-flex flex-wrap gap-2">
              <button
                class="btn btn-primary"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRight"
                aria-controls="offcanvasRight"
              >
                Toggle right offcanvas
              </button>

              <button
                class="btn btn-primary"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasBottom"
                aria-controls="offcanvasBottom"
              >
                Toggle bottom offcanvas
              </button>
            </div>

            <!-- right offcanvas -->
            <div
              class="offcanvas offcanvas-end"
              tabindex="-1"
              id="offcanvasRight"
              aria-labelledby="offcanvasRightLabel"
            >
              <div class="offcanvas-header">
                <h5 id="offcanvasRightLabel">Offcanvas Right</h5>
                <button
                  type="button"
                  class="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div class="offcanvas-body">...</div>
            </div>

            <!-- left offcanvas -->
            <div
              class="offcanvas offcanvas-bottom"
              tabindex="-1"
              id="offcanvasBottom"
              aria-labelledby="offcanvasBottomLabel"
            >
              <div class="offcanvas-header">
                <h5 id="offcanvasBottomLabel">Offcanvas Bottom</h5>
                <button
                  type="button"
                  class="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div class="offcanvas-body">...</div>
            </div>
          </div>
          <!-- end card body  -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title">Backdrop</h5>
          </div>
          <div class="card-body">
            <p class="card-title-desc">
              Scrolling the <code>&lt;body&gt;</code> element is disabled when
              an offcanvas and its backdrop are visible. Use the
              <code>data-bs-scroll</code> attribute to toggle
              <code>&lt;body&gt;</code> scrolling and
              <code>data-bs-backdrop</code> to toggle the backdrop.
            </p>

            <div class="d-flex flex-wrap gap-2">
              <button
                class="btn btn-primary"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasScrolling"
                aria-controls="offcanvasScrolling"
              >
                Enable body scrolling
              </button>
              <button
                class="btn btn-primary"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasWithBackdrop"
                aria-controls="offcanvasWithBackdrop"
              >
                Enable backdrop (default)
              </button>
              <button
                class="btn btn-primary"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasWithBothOptions"
                aria-controls="offcanvasWithBothOptions"
              >
                Enable both scrolling & backdrop
              </button>
            </div>

            <div
              class="offcanvas offcanvas-start"
              data-bs-scroll="true"
              data-bs-backdrop="false"
              tabindex="-1"
              id="offcanvasScrolling"
              aria-labelledby="offcanvasScrollingLabel"
            >
              <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="offcanvasScrollingLabel">
                  Colored with scrolling
                </h5>
                <button
                  type="button"
                  class="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div class="offcanvas-body">
                <p>
                  Try scrolling the rest of the page to see this option in
                  action.
                </p>
              </div>
            </div>
            <div
              class="offcanvas offcanvas-start"
              tabindex="-1"
              id="offcanvasWithBackdrop"
              aria-labelledby="offcanvasWithBackdropLabel"
            >
              <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="offcanvasWithBackdropLabel">
                  Offcanvas with backdrop
                </h5>
                <button
                  type="button"
                  class="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div class="offcanvas-body">
                <p>.....</p>
              </div>
            </div>
            <div
              class="offcanvas offcanvas-start"
              data-bs-scroll="true"
              tabindex="-1"
              id="offcanvasWithBothOptions"
              aria-labelledby="offcanvasWithBothOptionsLabel"
            >
              <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="offcanvasWithBothOptionsLabel">
                  Backdroped with scrolling
                </h5>
                <button
                  type="button"
                  class="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              <div class="offcanvas-body">
                <p>
                  Try scrolling the rest of the page to see this option in
                  action.
                </p>
              </div>
            </div>
          </div>
          <!-- end card body  -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
